(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('mobile-product-purchase')) {
    customElements.define('mobile-product-purchase', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.closest('product-sticky-bar');
        this.form = document.getElementById(this.getAttribute('form'));
        this.primaryButton = this.form?.querySelector('button[type="submit"]');
        this.productInfo = this.form?.closest('.product-info');
        this.footer = document.querySelector('.shopify-section--footer');
        this.restockButton = this.bar?.querySelector('[data-restock-trigger]');
        if (!this.bar || !this.primaryButton) return;

        this.abortController = new AbortController();
        this.mobile = matchMedia('(max-width: 699px)');
        this.updateVisibility = () => {
          const action = this.restockButton ? this.restockSource : this.primaryButton;
          const buttonRect = action?.getBoundingClientRect();
          const barHeight = this.bar.getBoundingClientRect().height;
          const consentHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tokushu-consent-height')) || 0;
          const visibleHeight = window.innerHeight - barHeight - consentHeight;
          const primaryVisible = buttonRect && buttonRect.top >= 0 && buttonRect.bottom <= visibleHeight;
          const footerVisible = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
          this.bar.classList.toggle('is-mobile-visible', !!action && this.mobile.matches && !primaryVisible && !footerVisible && !this.restockModalOpen());
        };

        this.modalObserver = new MutationObserver(() => {
          this.updateVisibility();
          if (this.openedFromSticky && !this.restockModalOpen()) {
            this.openedFromSticky = false;
            if (this.bar.classList.contains('is-mobile-visible')) this.restockButton?.focus({preventScroll: true});
          }
        });

        this.refreshObserver = () => {
          this.observer?.disconnect();
          this.restockSource = this.findRestockSource();
          if (this.restockButton) this.restockButton.disabled = !this.restockSource;
          const modal = document.getElementById('gw-stock-fulfilled-iframe');
          if (modal !== this.restockModal) {
            this.modalObserver.disconnect();
            this.restockModal = modal;
            if (modal) this.modalObserver.observe(modal, {attributes: true, attributeFilter: ['style', 'class', 'hidden']});
          }
          const consentHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tokushu-consent-height')) || 0;
          this.observer = new IntersectionObserver(this.updateVisibility, {
            rootMargin: '0px 0px -' + Math.ceil(this.bar.getBoundingClientRect().height + consentHeight) + 'px 0px',
            threshold: [0, 1]
          });
          this.observer.observe(this.restockSource || this.primaryButton);
          if (this.footer) this.observer.observe(this.footer);
          this.updateVisibility();
        };

        this.scheduleRefresh = () => {
          if (this.refreshFrame) return;
          this.refreshFrame = requestAnimationFrame(() => {
            this.refreshFrame = null;
            if (this.isConnected) this.refreshObserver();
          });
        };
        this.mobile.addEventListener('change', this.scheduleRefresh, {signal: this.abortController.signal});
        window.addEventListener('resize', this.scheduleRefresh, {signal: this.abortController.signal});
        document.addEventListener('tokushu:consent-layout', this.scheduleRefresh, {signal: this.abortController.signal});
        this.form.addEventListener('change', this.scheduleRefresh, {signal: this.abortController.signal});
        this.form.addEventListener('variant:change', this.scheduleRefresh, {signal: this.abortController.signal});
        this.barObserver = new ResizeObserver(this.scheduleRefresh);
        this.barObserver.observe(this.bar);

        if (this.restockButton && this.productInfo) {
          this.appObserver = new MutationObserver(this.scheduleRefresh);
          this.appObserver.observe(this.productInfo, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-product-id', 'data-variant-id', 'disabled', 'style', 'class']});
          this.appObserver.observe(document.body, {childList: true});
          this.restockButton.addEventListener('click', () => {
            const source = this.findRestockSource();
            if (!source) {
              this.refreshObserver();
              return;
            }
            this.openedFromSticky = true;
            source.click();
            this.scheduleRefresh();
          }, {signal: this.abortController.signal});
        }

        this.querySelector('[data-view-product-options]')?.addEventListener('click', () => {
          const picker = this.productInfo?.querySelector('variant-picker');
          if (!picker) return;
          picker.setAttribute('tabindex', '-1');
          picker.focus({preventScroll: true});
          picker.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        }, {signal: this.abortController.signal});
        this.refreshObserver();
      }

      findRestockSource() {
        if (!this.restockButton || !this.productInfo) return null;
        const variantId = this.getAttribute('variant-id');
        if (String(this.form.elements.namedItem('id')?.value) !== variantId) return null;
        return Array.from(this.productInfo.querySelectorAll('.gw-button-widget')).find(button =>
          button.dataset.productId === this.getAttribute('product-id') &&
          button.dataset.variantId === variantId &&
          !button.disabled && button.getClientRects().length > 0 && getComputedStyle(button).visibility !== 'hidden'
        ) || null;
      }

      restockModalOpen() {
        return !!this.restockModal && getComputedStyle(this.restockModal).display !== 'none' && getComputedStyle(this.restockModal).visibility !== 'hidden';
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.appObserver?.disconnect();
        this.modalObserver?.disconnect();
        this.barObserver?.disconnect();
        this.abortController?.abort();
        if (this.refreshFrame) cancelAnimationFrame(this.refreshFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-wholesale-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tk-wholesale-order')) {
    customElements.define('tk-wholesale-order', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-order-form]');
        if (!this.form || this.dataset.authorized !== 'true') return;
        this.controller?.abort();
        this.controller = new AbortController();
        this.fields = this.querySelector('[data-order-fields]');
        this.inputs = [...this.querySelectorAll('[data-variant-id]')];
        this.submitButton = this.querySelector('[data-submit]');
        this.error = this.querySelector('[data-error]');
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.currency = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
        this.busy = false;
        this.reviewRequired = false;
        this.fields.disabled = false;
        const options = { signal: this.controller.signal };
        this.form.addEventListener('input', () => this.updateSummary(), options);
        this.form.addEventListener('submit', event => this.addSelection(event), options);
        window.addEventListener('beforeunload', event => {
          if (this.dirty || this.busy) { event.preventDefault(); event.returnValue = ''; }
        }, options);
        window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); }, options);
        this.updateSummary();
      }

      disconnectedCallback() { this.controller?.abort(); }

      selection() {
        return this.inputs.filter(input => input.value !== '' && Number(input.value) !== 0 && !input.disabled);
      }

      updateSummary() {
        let count = 0;
        let total = 0;
        for (const input of this.inputs) {
          const quantity = Number(input.value);
          const selected = Number.isSafeInteger(quantity) && quantity > 0 && !input.disabled;
          input.closest('tr').dataset.selected = String(selected);
          if (!selected) continue;
          const row = input.closest('tr');
          let price = Number(row.dataset.price);
          const cartQuantity = Number(input.dataset.inCart);
          for (const tier of JSON.parse(row.dataset.priceBreaks)) {
            if (cartQuantity + quantity >= tier.quantity) price = tier.price;
          }
          count += quantity;
          total += quantity * price;
        }
        this.dirty = !this.reviewRequired && this.selection().length > 0;
        this.querySelector('[data-selected-count]').textContent = count;
        this.querySelector('[data-selected-total]').textContent = this.currency.format(total / 100);
        this.submitButton.disabled = !count || this.busy || this.reviewRequired;
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
        this.error.focus();
      }

      validateQuantity(input, fresh) {
        const quantity = Number(input.value);
        const total = quantity + Number(fresh.dataset.inCart);
        const minimum = Number(fresh.dataset.minimum);
        const increment = Number(fresh.dataset.increment);
        const maximum = fresh.dataset.maximum === '' ? Infinity : Number(fresh.dataset.maximum);
        return Number.isSafeInteger(quantity) && quantity > 0 && Number.isSafeInteger(total)
          && total >= minimum && total <= maximum && total % increment === 0;
      }

      async addSelection(event) {
        event.preventDefault();
        if (this.busy || this.reviewRequired) return;
        const selected = this.selection();
        if (!selected.length) { this.showError(this.messages.empty); return; }
        this.error.hidden = true;
        for (const input of selected) {
          input.setAttribute('aria-invalid', 'false');
          if (!this.validateQuantity(input, input)) {
            input.setAttribute('aria-invalid', 'true');
            this.showError(input.dataset.label + ': ' + this.messages.invalid);
            input.focus();
            return;
          }
        }
        this.busy = true;
        this.fields.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.submitButton.textContent = this.messages.adding;
        let postAttempted = false;
        try {
          const contextUrl = new URL(window.location.href);
          contextUrl.searchParams.delete('sections');
          contextUrl.searchParams.set('section_id', this.dataset.sectionId);
          const contextResponse = await fetch(contextUrl, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(20000) });
          if (!contextResponse.ok) throw new Error(this.messages.network);
          const contextDocument = new DOMParser().parseFromString(await contextResponse.text(), 'text/html');
          const current = contextDocument.querySelector('tk-wholesale-order');
          if (!current || current.dataset.authorized !== 'true' || current.dataset.locationId !== this.dataset.locationId || current.dataset.currency !== this.dataset.currency) {
            throw new Error(this.messages.changed);
          }
          const freshInputs = new Map([...current.querySelectorAll('[data-variant-id]')].map(input => [input.dataset.variantId, input]));
          const items = selected.map(input => {
            const fresh = freshInputs.get(input.dataset.variantId);
            if (!fresh || fresh.disabled || !this.validateQuantity(input, fresh)) {
              throw new Error(input.dataset.label + ': ' + this.messages.unavailable);
            }
            return { id: input.dataset.variantId, quantity: Number(input.value) };
          });
          postAttempted = true;
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items }), signal: AbortSignal.timeout(25000)
          });
          const result = await response.json();
          if (!response.ok || !Array.isArray(result.items)) {
            const detail = typeof result.description === 'string' ? result.description + ' ' : '';
            throw new Error(detail + this.messages.review);
          }
          this.dirty = false;
          this.busy = false;
          this.reviewRequired = true;
          for (const input of this.inputs) input.value = '0';
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.busy = false;
          if (postAttempted) {
            this.reviewRequired = true;
            this.dirty = false;
            this.querySelector('[data-review]').hidden = false;
            this.showError(error.name === 'TimeoutError' || error.name === 'TypeError' || error.name === 'SyntaxError' ? this.messages.review : error.message);
          } else {
            this.fields.disabled = false;
            this.showError(error.name === 'TimeoutError' || error.name === 'TypeError' ? this.messages.network : error.message);
          }
          this.form.removeAttribute('aria-busy');
          this.submitButton.textContent = this.messages.button;
          this.updateSummary();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
